import { Injectable } from "@angular/core";
import { HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseService } from "src/app/helpers/base.service";

export interface PhotoUploadResponse {
  id: string;
  title: string;
  fileName: string;
  fileSize: number;
  uploadDate: string;
  patientId: string;
  url: string;
}

export interface PatientPhoto {
  id: string;
  title: string;
  url: string;
  uploadDate: Date;
  dateTaken?: Date;
  s3FileId: string;
  patientId: string;
}

export interface PatientPhotosResponse {
  photos: PatientPhoto[];
  totalCount: number;
  currentPage: number;
  pageSize: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

@Injectable({
  providedIn: "root",
})
export class PhotoService extends BaseService {
    public uploadPatientPhoto(patientId: string, file: File, title: string, dateTaken: Date): Observable<HttpEvent<PhotoUploadResponse>> {
        const route = `${this.apiUrl}/Photo/UploadPatientPhoto`;
        let formData: FormData = new FormData();
        // For more complex validation, switch to using FormGroups and FormArrays
        formData.append("file", file, file.name);
        formData.append("title", title);
        formData.append("patientId", patientId);
        formData.append("dateTaken", dateTaken.toISOString());

        return this.http.post<PhotoUploadResponse>(route, formData, {
          reportProgress: true,
          observe: 'events',
        });
      }

    public getPatientPhotos(patientId: string, page: number = 1, pageSize: number = 5): Observable<PatientPhotosResponse> {
        const route = `${this.apiUrl}/Photo/GetPatientPhotos/${patientId}?page=${page}&pageSize=${pageSize}`;
        return this.http.get<PatientPhotosResponse>(route);
    }

    // Use Presigned URL for downloading photos in the future
    public downloadPatientPhoto(photoId: string, filename: string): Observable<Blob> {
        const route = `${this.apiUrl}/Photo/DownloadPatientPhoto/${photoId}`;
        return this.http.get(route, { 
            responseType: 'blob',
            headers: {
                'Accept': 'application/octet-stream'
            }
        });
    }
}
